import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User, KeyRound, ArrowLeft, Sun, Moon, Loader2 } from 'lucide-react';

export const AdminLogin = ({ credentials, setCredentials, login, loading, isDarkMode, toggleTheme }) => {
  const navigate = useNavigate();

  return (
    <div className={`min-h-screen flex items-center justify-center p-4 ${
      isDarkMode ? 'bg-zinc-950' : 'bg-zinc-100'
    }`}>
      <div className={`w-full max-w-sm rounded-lg border p-8 ${
        isDarkMode ? 'bg-zinc-900 border-zinc-800' : 'bg-white border-zinc-200'
      }`}>
        <button
          onClick={toggleTheme}
          className={`absolute top-6 right-6 p-2 rounded-md transition-colors ${
            isDarkMode ? 'text-zinc-400 hover:text-zinc-200 hover:bg-zinc-800' : 'text-zinc-500 hover:text-zinc-700 hover:bg-zinc-100'
          }`}
          data-testid="theme-toggle"
        >
          {isDarkMode ? <Sun size={18} /> : <Moon size={18} />}
        </button>

        <div className="text-center mb-8">
          <div className="w-12 h-12 bg-demoraes-green rounded-lg flex items-center justify-center mx-auto mb-4">
            <Lock size={22} className="text-white" />
          </div>
          <h1 className={`text-xl font-bold tracking-tight ${isDarkMode ? 'text-zinc-100' : 'text-zinc-900'}`}
            style={{ fontFamily: 'Manrope, sans-serif' }}>
            Painel Administrativo
          </h1>
          <p className={`text-sm mt-1 ${isDarkMode ? 'text-zinc-500' : 'text-zinc-500'}`}>
            DEMoraes Consultoria
          </p>
        </div>

        <div className="space-y-3">
          <div className="relative">
            <User size={16} className={`absolute left-3 top-1/2 -translate-y-1/2 ${isDarkMode ? 'text-zinc-500' : 'text-zinc-400'}`} />
            <input
              type="text"
              placeholder="Usuário"
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              onKeyDown={(e) => e.key === 'Enter' && login()}
              className={`w-full pl-10 pr-4 py-3 text-sm border rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-demoraes-green/30 focus:border-demoraes-green ${
                isDarkMode
                  ? 'bg-zinc-800 border-zinc-700 text-zinc-100 placeholder-zinc-500'
                  : 'bg-white border-zinc-300 text-zinc-900 placeholder-zinc-400'
              }`}
              data-testid="admin-username"
            />
          </div>
          <div className="relative">
            <KeyRound size={16} className={`absolute left-3 top-1/2 -translate-y-1/2 ${isDarkMode ? 'text-zinc-500' : 'text-zinc-400'}`} />
            <input
              type="password"
              placeholder="Senha"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              onKeyDown={(e) => e.key === 'Enter' && login()}
              className={`w-full pl-10 pr-4 py-3 text-sm border rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-demoraes-green/30 focus:border-demoraes-green ${
                isDarkMode
                  ? 'bg-zinc-800 border-zinc-700 text-zinc-100 placeholder-zinc-500'
                  : 'bg-white border-zinc-300 text-zinc-900 placeholder-zinc-400'
              }`}
              data-testid="admin-password"
            />
          </div>
        </div>

        <button
          onClick={login}
          disabled={loading}
          className="w-full mt-5 bg-demoraes-green hover:bg-demoraes-green/90 text-white font-semibold py-3 rounded-md transition-all duration-200 disabled:opacity-50 text-sm"
          data-testid="admin-login-btn"
        >
          {loading ? (
            <span className="flex items-center justify-center gap-2">
              <Loader2 size={16} className="animate-spin" /> Entrando...
            </span>
          ) : 'Entrar'}
        </button>

        <button
          onClick={() => navigate('/')}
          className={`w-full mt-3 text-sm py-2 transition-colors flex items-center justify-center gap-1 ${
            isDarkMode ? 'text-zinc-500 hover:text-zinc-300' : 'text-zinc-500 hover:text-zinc-700'
          }`}
          data-testid="back-to-survey"
        >
          <ArrowLeft size={14} /> Voltar à Pesquisa
        </button>
      </div>
    </div>
  );
};
